import React, { useState, useEffect } from "react";
import { Box, Typography, Card, CardContent, Avatar } from "@mui/material";
import { useParams } from "react-router-dom";
import { baseUrl, get } from "../../../services/api-services";
import { GalaryTimeLine, PaymentTimeLine, TimelineItem, UserTimeLine } from "../../../modules/UserTimeLine";
import { convertToTime, formatDate, formatDatecase } from "../../../modules/ConvertDate";


const Timeline = ({ userData }) => {
    const [measurement, setMeasurement] = useState([]);
    const [galary, setGalary] = useState([]);
    const [user, setUser] = useState([]);
    const [payment, setPayment] = useState([]);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    // console.log(userData, "djshuwefwefdied")
    const fetchData = React.useCallback(async () => {
        try {
            const measurementRes = await get(`/Measurements?filter={"where":{"customerId":"${id}"},"order":"recordedAt DESC"}`);
            setMeasurement(measurementRes?.data);
            const galaryRes = await get(`/Galleries?filter={"where" : { "customerId" : "${id}"}}`);
            setGalary(galaryRes?.data);
            const userRes = await get(`/UserPrograms?filter={"where" : { "customerId" :"${id}", "status" : "active"}, "include" : "invoice"}`);
            setUser(userRes?.data);
            const paymentRes = await get(`/Payments?filter={"where" : { "customerId" :"${id}"}, "include" : "program"}`);
            setPayment(paymentRes?.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    }, [id]);
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    if (loading) {
        return <Typography>Loading...</Typography>;
    }

    return (
        <Box>
            {galary?.map((item, index) => (
                <GalaryTimeLine
                    key={index}
                    image={item?.image}
                    date={formatDatecase(item.createdAt)}
                    time={convertToTime(item.createdAt)}

                />
            ))}
            {measurement?.map((item, index) => (
                <TimelineItem
                    key={index}
                    date={formatDatecase(item?.createdAt)}
                    time={convertToTime(item?.createdAt)}
                    label={item?.type}
                    value={item.value}
                    unit={item.unit}
                    isLast={index === measurement?.length - 1}
                />
            ))}
            {user?.map((item, index) => (
                <UserTimeLine
                    key={index}
                    status={item?.invoice?.status}
                    price={item?.invoice?.purchaseProgram?.price}
                    date={formatDatecase(item.createdAt)}
                    time={convertToTime(item.createdAt)}
                    title={item?.invoice?.purchaseProgram?.title}
                    enrollOndate={formatDate(item?.invoice?.enrollOn)}
                    duration={item?.invoice?.purchaseProgram?.duration}

                />
            ))}

            {payment?.map((item, index) => (
                <PaymentTimeLine
                    key={index}
                    amount={item?.amount}
                    paymentMode={item?.paymentMode}
                    title={item?.program?.title}
                    date={formatDatecase(item.createdAt)}
                    time={convertToTime(item.createdAt)}
                />
            ))}
            <Card sx={{ marginBottom: 4, padding: 2 }}>
                <CardContent display='flex' gap={3}>
                    <Box className='flex justify-between'>
                        <Box display='flex' gap={3} alignItems='center'>
                            <Avatar src={userData.image ? `${baseUrl}/Uploads/profile-pic/download/${userData.image}` : `http://apps.eulogik.com/weightwonder-web/assets/img/userProfile.png`} alt='user' />
                            <Box>
                                <Typography variant="body1" color="text.secondary">
                                    {userData?.name || ""}
                                </Typography>
                                <Typography variant="body1" color="text.secondary">
                                    +91 {userData?.mobile || ""}
                                </Typography>
                                <Typography variant="body1" color="text.secondary">
                                    {userData?.email || ""}
                                </Typography>
                            </Box>
                        </Box>
                        <Typography> {formatDatecase(userData?.createdAt)}</Typography>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default Timeline;

